import { create } from 'twrnc';
import tailwindConfig from '../../tailwind.config.js'; // <- Update the path as needed

// Create the customized version...
export const tw = create(tailwindConfig);
